import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';

// gsap.config({
//   nullTargetWarn: false,
// });
function buttonFunction() {
	if($(".wp-block-keztablocks-button__link").length > 0) {
		$(".wp-block-keztablocks-button__link").each(function() {
			var self = $(this),
			    text = self.find('.wp-block-keztablocks-button__text'),
			    dataHoverTextColor = self.attr("data-tcolor"),
			    dataHoverBorderColor = self.attr("data-bcolor"),
			    tl = gsap.timeline({paused:true});

			tl.to(text, {duration: 0.3, color: dataHoverTextColor})
			.to(self, {duration: 0.3, borderColor: dataHoverBorderColor}, "<");

			self.on("mouseenter", () => {
				tl.play();
			}).on("mouseleave", () => {
				tl.reverse();
			})
		})
	}
}
buttonFunction();